<template>
  <dash-layout>
  
    <template slot="dash-title" v-if="id != 'new'">
       <!-- <v-btn  outlined @click="$router.push(`/audit-jobs`).catch(err => {})">Go To Audits</v-btn > -->
      <span v-if="activeElection.name">
        {{ activeElection.name }}
        <v-chip
          small
          color="green"
          text-color="white"
          style="margin-bottom: 16px; margin-left: -8px;"
        >
          {{ activeElection.role }}
        </v-chip>
      </span>        
      <span v-else>Loading...</span>
    </template>
    <template slot="dash-title" v-else>New Election</template>
    <template slot="dash-body">
        
      <v-tabs show-arrows v-model="tab" class="mb-4">
        <div class="back-btn" style="line-height: 50px;">
        <v-btn icon @click.prevent="backProject()" class="mb-1">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn><span>Back</span>
          </div>
        <v-tab :ripple="false" :ref="'btnElectionProperties'">Election Properties</v-tab>
        <v-tab 
          :ripple="false" 
          :ref="'btnElectionFiles'"
          :disabled="id == 'new'"
          v-show="activeElection.role == 'Auditor' || activeElection.role == 'Uploader'"
        >Election Files</v-tab>
        <v-tab 
          :ripple="false" 
          :ref="'btnUploadedFiles'"
          :disabled="id == 'new'"
          v-show="activeElection.role == 'Auditor' || activeElection.role == 'Uploader'"
        >File Upload</v-tab>
        <v-tab 
          :ripple="false" 
          :ref="'btnRequestFiles'"
          :disabled="id == 'new'"
          v-show="activeElection.role == 'Auditor' || activeElection.role == 'Uploader'"
        >Upload Requests</v-tab>
        <v-tab
          :ripple="false" 
          :ref="'btnUsers'"
          :disabled="id == 'new'"
          v-show="activeElection.role == 'Auditor'"
        >Users</v-tab>
         <v-tab :ripple="false" :ref="'gotoaudit'" @click="$router.push({ name: 'AuditJobsList', params: { electionId: id } })">Audits</v-tab>
      </v-tabs>

      <transition name="component-fade" mode="out-in">
        <keep-alive>
          <component v-bind:is="tabs[activeTab].component" :selectedDistrict="selectedDistrict" :electionId="id"></component>        </keep-alive>
      </transition>

    </template>
  </dash-layout>

</template>

<script>
  import {mapGetters} from 'vuex'
  import DashLayout from '../../containers/Layout'
  import Overview from './Overview'
  import Upload from './UploadSets'
  import FileUpload from './FileUpload'
  import Request from './RequestFiles'
  import ElectionUsers from './ElectionUsers'

  export default {
    name: 'ElectionLayout',
    props: ['id'],

    data() {
      return {
        currentTabComponent: '',
        activeTab: 0,
        tabs: [
          { name: 'Election Properties', component: 'Overview'},
          { name: 'Election Files', component: 'Upload'},
          { name: 'File Upload', component: 'FileUpload'},
          { name: 'Upload Requests', component: 'Request'},
          { name: 'Users', component: 'ElectionUsers'},
          ],
        selectedDistrict: '',
        districtId: null
      }
    },

    mounted() {
      console.log(this.activeElection.name)
      this.selectedDistrict = this.$route.params.selectedDistrict
      // Track districtId from route params or query to maintain context
      this.districtId = this.$route.params.districtId || this.$route.query.districtId || null
    },


    computed: {
      ...mapGetters(['elections', 'activeElection', 'electionLoading', 'user']),
      tab: {
        get () {
          return this.activeTab
        },
        set (value) {
          this.activeTab = value
        }
      }
    },

    components: {
      DashLayout,
      Overview,
      Upload,
      FileUpload,
      Request,
      ElectionUsers,
    },

    methods: {
      backProject() {
        // If we're in district context (from route query/params or active election), navigate accordingly
        const districtId = this.districtId || (this.activeElection.district ? this.activeElection.district.id : null)
        
        if (this.id === 'new') {
          // If canceling/back from New Election, go to election list for that district
          if (districtId) {
            this.$router.push({ name: 'ElectionList', params: { districtId: districtId } }).catch((err) => {})
          } else {
            this.$router.push('/elections').catch((err) => {})
          }
        } else {
          // If viewing an existing election from district context, go back to the district view
          if (districtId) {
            // Go back to the district view
            this.$router.push({ name: 'DistrictView', params: { id: districtId } }).catch((err) => {})
          } else if (this.activeElection.district) {
            // Fallback: if election has a district but no context, go to election list for that district
            this.$router.push({ name: 'ElectionList', params: { districtId: this.activeElection.district.id } }).catch((err) => {})
          } else {
            // Default: go to all elections
            this.$router.push('/elections').catch((err) => {})
          }
        }
      }
    },

    watch: {
      activeElection(){
      },
      '$route'(to, from) {
        // Update districtId when route changes
        this.districtId = to.params.districtId || to.query.districtId || null
        this.selectedDistrict = to.params.selectedDistrict
      }
    }
  }
</script>
